"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var skewProtection_exports = {};
__export(skewProtection_exports, {
  checkSkewAndReload: () => checkSkewAndReload,
  isVersionStale: () => isVersionStale,
  setupSkewProtection: () => setupSkewProtection
});
module.exports = __toCommonJS(skewProtection_exports);
var import_constants = require("./constants");
var import_getURL = require("./getURL");
var import_dynamicImport = require("./utils/dynamicImport");
var stale = false;
var polling = null;
var inFlightCheck = null;
function isVersionStale() {
  if (stale) return true;
  if (typeof window !== "undefined" && window.__oneVersionStale) return true;
  return false;
}
function markStale(version) {
  stale = true;
  if (typeof window !== "undefined") {
    ;
    window.__oneVersionStale = true;
    window.dispatchEvent(new CustomEvent("one-version-update", {
      detail: {
        version
      }
    }));
  }
}
function checkSkewAndReload() {
  if (typeof window === "undefined") return Promise.resolve(false);
  if (process.env.ONE_SKEW_PROTECTION === "false") return Promise.resolve(false);
  if (isVersionStale()) {
    (0, import_dynamicImport.handleSkewError)();
    return Promise.resolve(true);
  }
  if (inFlightCheck) return inFlightCheck;
  inFlightCheck = (async function() {
    try {
      var res = await fetch(`${(0, import_getURL.getURL)()}/version.json`, {
        headers: {
          "cache-control": "no-cache",
          pragma: "no-cache"
        }
      });
      if (!res.ok) return false;
      var data = await res.json();
      if (data.version && data.version !== import_constants.CACHE_KEY) {
        markStale(data.version);
        (0, import_dynamicImport.handleSkewError)();
        return true;
      }
      return false;
    } catch (unused) {
      return false;
    } finally {
      inFlightCheck = null;
    }
  })();
  return inFlightCheck;
}
function setupSkewProtection() {
  if (typeof window === "undefined") return;
  if (process.env.NODE_ENV === "development") return;
  if (process.env.ONE_SKEW_PROTECTION !== "proactive") return;
  var POLL_INTERVAL = 12e4;
  var baseUrl = (0, import_getURL.getURL)();
  async function check() {
    try {
      var res = await fetch(`${baseUrl}/version.json`, {
        headers: {
          "cache-control": "no-cache",
          pragma: "no-cache"
        }
      });
      if (!res.ok) {
        polling = setTimeout(check, POLL_INTERVAL);
        return;
      }
      var data = await res.json();
      if (data.version !== import_constants.CACHE_KEY) {
        markStale(data.version);
        return;
      }
    } catch (unused) {
    }
    polling = setTimeout(check, POLL_INTERVAL);
  }
  polling = setTimeout(check, POLL_INTERVAL);
}
//# sourceMappingURL=skewProtection.js.map
